import { render, staticRenderFns } from "./agregarDireccion.vue?vue&type=template&id=135efde0&"
import script from "./agregarDireccion.vue?vue&type=script&lang=js&"
export * from "./agregarDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports